import Vue from 'vue'
import ElementUI, { Form } from 'element-ui'
import App from './App'
import store from './store'
import router from './router'
import vdr from 'vue-draggable-resizable-gorkys'
import '@/custom-component' // 注册自定义组件

import './assets/iconfont/iconfont.css'
import '@/styles/animate.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/reset.css'
import 'remixicon/fonts/remixicon.css'
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'
//引入公共配置文件
import rwConfig from './assets/js/rwConfig.js'
Vue.prototype.$rwConfig = rwConfig;
//引入公共方法文件
import rwJS from './assets/js/rwJS.js'
Vue.prototype.$rwJS = new rwJS();
Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false
Vue.component('vdr', vdr)
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp);
router.beforeEach((to, from, next) => {
    if (store.state.routeChange == false) {
        next()
    }
    store.commit('setComponentData', [])
})
// const isLogin = getCookie('islogin')
// if (isLogin !== 'yes') {
//     router.push({ path: '/404' })
// }
function getCookie(name) {
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
            return arr[1];
        }
    }
    return "";
}


new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js